module.exports = __webpack_public_path__ + "f3b7522ce2616e0c02d5929d933d56a0.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/mythos-1.jpg
// module id = 666
// module chunks = 0